import React from 'react';

import Cookies from 'js-cookie';

import { CreateCreditApplicationAttributionContext } from 'src/clients/Network/gql/build/TermsAndConditionsPageCreateCreditApplicationMutation.graphql';

// Campaign-specific cookie keys
export const CkSubIdCookieKey = 'x1_ck_sub_id';
export const CkBadgeCookieKey = 'x1_ck_badge';
export const CkPayloadCookieKey = 'x1_ck_payload';
export const CkOfferVariantCookieKey = 'x1_ck_offer_variant';
export const CkCampaignCookieKey = 'x1_ck_campaign';
export const X1InviteCookieKey = 'x1_invite_slug';

// Generic campaign cookie keys
export const InviteCookieKey = 'invite';
export const UtmSourceCookieKey = 'utm_source';
export const UtmMediumCookieKey = 'utm_medium';
export const UtmCampaignCookieKey = 'utm_campaign';
export const UtmContentCookieKey = 'utm_content';
export const UtmTermCookieKey = 'utm_term';

// Referral cookie keys
export const ReferralCodeCookieKey = 'referral_code';

export enum Campaign {
  AgenticCard = 'agentic-card',
  NfaStanford = 'nfa-stanford',
}

const DEFAULT_UTM_SOURCE = 'rh-card-web';

export const getAttribution = (): CreateCreditApplicationAttributionContext => {
  const invite = Cookies.get(InviteCookieKey);
  const utmSource = Cookies.get(UtmSourceCookieKey) ?? DEFAULT_UTM_SOURCE;
  const utmCampaign = Cookies.get(UtmCampaignCookieKey);
  const utmMedium = Cookies.get(UtmMediumCookieKey);
  const utmContent = Cookies.get(UtmContentCookieKey);
  const utmTerm = Cookies.get(UtmTermCookieKey);
  const baseAttribution: CreateCreditApplicationAttributionContext = {
    inviteKey: invite,
    utmParams: { source: utmSource, medium: utmMedium, campaign: utmCampaign, content: utmContent, term: utmTerm },
  };

  // Prefer X1 invite over CK sub ID and badge
  const x1InviteSlug = Cookies.get(X1InviteCookieKey);
  const affiliateAttribution = !!x1InviteSlug
    ? {
        x1InviteSlug: x1InviteSlug,
      }
    : {
        creditKarmaTrackingId: Cookies.get(CkSubIdCookieKey),
        creditKarmaLightboxBadge: Cookies.get(CkBadgeCookieKey),
        creditKarmaTrackingPayload: Cookies.get(CkPayloadCookieKey),
        creditKarmaOfferVariant: Cookies.get(CkOfferVariantCookieKey),
        creditKarmaCampaign: Cookies.get(CkCampaignCookieKey),
      };

  return {
    ...baseAttribution,
    ...affiliateAttribution,
  };
};

export const getReferralCode = () => {
  return Cookies.get(ReferralCodeCookieKey);
};

export const useIsNfaStanford = () => {
  const { inviteKey, utmParams } = getAttribution();
  return inviteKey != null && utmParams?.campaign === Campaign.NfaStanford;
};
